import getGroupedFemaleNorwegianData from './items/norwegianFemaleData/getGroupedFemaleNorwegianData';
import getGroupedMaleNorwegianData from './items/norwegianMaleData/getGroupedMaleNorwegianData';
import getGroupedNorwegianSurnamesData from './items/norwegianSurnamesData/getGroupedNorwegianSurnamesData';

import lifeareas_en from '@/assets/lifeareas_en.json';
import lifeareas_no from '@/assets/lifeareas_no.json';

import numbersInRange from './items/utils/numbersInRange';

export default async () => {
    const femaleNorwegianData = await getGroupedFemaleNorwegianData();
    const maleNorwegianData = await getGroupedMaleNorwegianData();
    const norwegianSurnamesData = await getGroupedNorwegianSurnamesData();

    const systems = [
        {
            id: 'singlesys',
            name: 'Single System',
            label: 'Small',
            journeys: [
                {
                    name: 'Big steps with single shapes',
                    steps: [
                        { name: 'intro' },
                        {
                            name: 'From 0 to 4',
                            items: [
                                { name: 'wheel', name_no: 'hjul', number: '0' },
                                { name: 'forefinger', name_no: 'pekefinger', number: '1' },
                                { name: 'swan', name_no: 'svane', number: '2' },
                                { name: 'mask', name_no: 'maske', number: '3' },
                                { name: 'bell', name_no: 'bjelle', number: '4' }
                            ]
                        },
                        {
                            name: 'From 5 to 10',
                            items: [
                                { name: 'hook', name_no: 'krok', number: '5' },
                                { name: 'paper clip', name_no: 'binders', number: '6' },
                                { name: 'cliff', name_no: 'klippe', number: '7' },
                                { name: 'snowman', name_no: 'snømann', number: '8' },
                                { name: 'sunflower', name_no: 'solsikke', number: '9' },
                                { name: 'speedometer', name_no: 'speedometer', number: '10' }
                            ]
                        },
                        { name: 'quiz' }
                    ]
                }
            ]
        },
        {
            id: 'rhymesys',
            name: 'Rhyme System',
            label: 'Small',
            journeys: [
                {
                    name: 'Fun with rhyme',
                    steps: [
                        { name: 'intro' },
                        {
                            name: 'From 1 to 7',
                            items: [
                                { name: 'sun', name_no: 'ben', number: '1' },
                                { name: 'shoe', name_no: 'do', number: '2' },
                                { name: 'tree', name_no: 'tre', number: '3' },
                                { name: 'door', name_no: 'slire', number: '4' },
                                { name: 'dive (scuba)', name_no: 'hjem', number: '5' },
                                { name: 'sticks (drum)', name_no: 'heks', number: '6' },
                                { name: 'heaven', name_no: 'tyv', number: '7' }
                            ]
                        },
                        {
                            name: 'From 8 to 14',
                            items: [
                                { name: 'bait (fishing)', name_no: 'rotte', number: '8' },
                                { name: 'wine', name_no: 'ski', number: '9' },
                                { name: 'hen', name_no: 'politi', number: '10' },
                                { name: 'seven-eleven', name_no: 'elven', number: '11' },
                                { name: 'shelf', name_no: 'troll', number: '12' },
                                { name: 'tight jeans', name_no: 'hetten', number: '13' },
                                { name: 'farting', name_no: 'skjorten', number: '14' }
                            ]
                        },
                        {
                            name: 'From 15 to 20',
                            items: [
                                { name: '50 Cent (rapper)', name_no: 'skremten (spøkelse)', number: '15' },
                                { name: 'sunscreen', name_no: 'heisen', number: '16' },
                                {
                                    name:
                                        'silver screen (a white or silvered surface where pictures can be projected for viewing)',
                                    name_no: 'nøtten',
                                    number: '17'
                                },
                                { name: 'racing', name_no: 'hatten', number: '18' },
                                { name: 'fine green (golf course)', name_no: 'dritten', number: '19' },
                                { name: 'penny', name_no: 'flue', number: '20' }
                            ]
                        },
                        { name: 'quiz' }
                    ]
                }
            ]
        },
        {
            id: 'alphabetsys',
            name: 'Alphabet System',
            label: 'Medium',
            journeys: [
                {
                    name: 'Alphabet street',
                    steps: [
                        { name: 'intro' },
                        {
                            name: 'From a to j',
                            items: [
                                { name: 'ape', name_no: 'ape', number: 'a-1' },
                                { name: 'bear', name_no: 'bjørn', number: 'b-2' },
                                { name: 'chihuaua', name_no: 'chihuaua', number: 'c-3' },
                                { name: 'dolphin', name_no: 'delfin', number: 'd-4' },
                                { name: 'elephant', name_no: 'elefant', number: 'e-5' },
                                { name: 'flamingo', name_no: 'flamingo', number: 'f-6' },
                                { name: 'giraffe', name_no: 'giraff', number: 'g-7' },
                                { name: 'horse', name_no: 'hest', number: 'h-8' },
                                { name: 'iguana', name_no: 'iguana', number: 'i-9' },
                                { name: 'jaguar', name_no: 'jaguar', number: 'j-10' }
                            ]
                        },
                        {
                            name: 'From k to t',
                            items: [
                                { name: 'kangaroo', name_no: 'kenguru', number: 'k-11' },
                                { name: 'lama', name_no: 'lama', number: 'l-12' },
                                { name: 'mouse', name_no: 'mus', number: 'm-13' },
                                { name: 'nemo', name_no: 'nemo', number: 'n-14' },
                                { name: 'otter', name_no: 'oter', number: 'o-15' },
                                { name: 'panda', name_no: 'panda', number: 'p-16' },
                                { name: 'quetzal', name_no: 'quetzal', number: 'q-17' },
                                { name: 'reindeer', name_no: 'reinsdyr', number: 'r-18' },
                                { name: 'sea horse', name_no: 'sjøhest', number: 's-19' },
                                { name: 'tiger', name_no: 'tiger', number: 't-20' }
                            ]
                        },
                        {
                            name: 'From u to z and beyond',
                            items: {
                                en: [
                                    { name: 'uakari monkey', number: 'u-21' },
                                    { name: 'vampire bat', number: 'v-22' },
                                    { name: 'walrus', number: 'w-23' },
                                    { name: 'spider (looks like x)', number: 'x-24' },
                                    { name: 'yak', number: 'y-25' },
                                    { name: 'zebra', number: 'z-26' }
                                ],

                                no: [
                                    { name: 'ugle', number: 'u-21' },
                                    { name: 'vampyr-flaggermus', number: 'v-22' },
                                    { name: 'hvalross (høres ut som W)', number: 'w-23' },
                                    { name: 'edderkopp (ligner på X)', number: 'x-24' },
                                    { name: 'yak-okse', number: 'y-25' },
                                    { name: 'zebra', number: 'z-26' },
                                    { name: 'ærfugl', number: 'æ-27' },
                                    { name: 'øyenstikker', number: 'ø-28' },
                                    { name: 'ål', number: 'å-29' },
                                    { name: 'punktum = pinnsvin', number: 'punktum-30' }
                                ]
                            }
                        },
                        { name: 'quiz' }
                    ]
                }
            ]
        },
        {
            id: 'doublesys',
            name: 'Double System',
            label: 'Large',
            journeys: [
                {
                    name: 'Giant steps with double shapes',
                    steps: [
                        { name: 'intro' },
                        {
                            name: 'Brain: 00 to 10',
                            items: {
                                en: [
                                    ...numbersInRange(0, 10).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(0, 10).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Knowledge: 11 to 33',
                            items: {
                                en: [
                                    ...numbersInRange(11, 33).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(11, 33).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Mind: 34 to 52',
                            items: {
                                en: [
                                    ...numbersInRange(34, 52).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(34, 52).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Body: 53 to 66',
                            items: {
                                en: [
                                    ...numbersInRange(53, 66).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(53, 66).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Soul: 67 to 78',
                            items: {
                                en: [
                                    ...numbersInRange(67, 78).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(67, 78).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Career: 79 to 89',
                            items: {
                                en: [
                                    ...numbersInRange(79, 89).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(79, 89).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Leisure: 90 to 99',
                            items: {
                                en: [
                                    ...numbersInRange(90, 99).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(90, 99).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        { name: 'quiz' }
                    ]
                }
            ]
        },
        {
            id: 'olpasys',
            name: 'Olpa System',
            label: 'XL',
            journeys: [
                {
                    name: 'Speed memory with people',
                    steps: [
                        { name: 'intro' },
                        {
                            name: 'Brain: 00 to 10',
                            items: {
                                en: [
                                    ...numbersInRange(0, 10).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(0, 10).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Knowledge: 11 to 33',
                            items: {
                                en: [
                                    ...numbersInRange(11, 33).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(11, 33).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Mind: 34 to 52',
                            items: {
                                en: [
                                    ...numbersInRange(34, 52).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(34, 52).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Body: 53 to 66',
                            items: {
                                en: [
                                    ...numbersInRange(53, 66).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(53, 66).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Soul: 67 to 78',
                            items: {
                                en: [
                                    ...numbersInRange(67, 78).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(67, 78).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Career: 79 to 89',
                            items: {
                                en: [
                                    ...numbersInRange(79, 89).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(79, 89).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Leisure: 90 to 99',
                            items: {
                                en: [
                                    ...numbersInRange(90, 99).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(90, 99).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        { name: 'quiz' }
                    ]
                },
                {
                    name: 'Speed memory with actions',
                    steps: [
                        { name: 'intro' },
                        {
                            name: 'Brain: 00 to 10',
                            items: {
                                en: [
                                    ...numbersInRange(0, 10).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(0, 10).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Knowledge: 11 to 33',
                            items: {
                                en: [
                                    ...numbersInRange(11, 33).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(11, 33).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Mind: 34 to 52',
                            items: {
                                en: [
                                    ...numbersInRange(34, 52).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(34, 52).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Body: 53 to 66',
                            items: {
                                en: [
                                    ...numbersInRange(53, 66).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(53, 66).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Soul: 67 to 78',
                            items: {
                                en: [
                                    ...numbersInRange(67, 78).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(67, 78).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Career: 79 to 89',
                            items: {
                                en: [
                                    ...numbersInRange(79, 89).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(79, 89).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        {
                            name: 'Leisure: 90 to 99',
                            items: {
                                en: [
                                    ...numbersInRange(90, 99).map(number =>
                                        lifeareas_en.find(stepData => stepData.number === number)
                                    )
                                ],
                                no: [
                                    ...numbersInRange(90, 99).map(number =>
                                        lifeareas_no.find(stepData => stepData.number === number)
                                    )
                                ]
                            }
                        },
                        { name: 'quiz' }
                    ]
                }
            ]
        },
        {
            id: 'namesys',
            name: 'Name System',
            label: 'XXL',
            type: 'grouped',
            groups: [
                {
                    name: 'Norwegian names',
                    journeys: [
                        {
                            name: 'Top 100 female names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names', data: femaleNorwegianData[0] },
                                { name: '11 to 20 names', data: femaleNorwegianData[1] },
                                { name: '21 to 30 names', data: femaleNorwegianData[2] },
                                { name: '31 to 40 names', data: femaleNorwegianData[3] },
                                { name: '41 to 50 names', data: femaleNorwegianData[4] },
                                { name: '51 to 60 names', data: femaleNorwegianData[5] },
                                { name: '61 to 70 names', data: femaleNorwegianData[6] },
                                { name: '71 to 80 names', data: femaleNorwegianData[7] },
                                { name: '81 to 90 names', data: femaleNorwegianData[8] },
                                { name: '91 to 100 names', data: femaleNorwegianData[9] },
                                { name: '101 to 109 names', data: femaleNorwegianData[10] },
                                { name: 'quiz' }
                            ]
                        },
                        {
                            name: 'Top 100 male names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names', data: maleNorwegianData[0] },
                                { name: '11 to 20 names', data: maleNorwegianData[1] },
                                { name: '21 to 30 names', data: maleNorwegianData[2] },
                                { name: '31 to 40 names', data: maleNorwegianData[3] },
                                { name: '41 to 50 names', data: maleNorwegianData[4] },
                                { name: '51 to 60 names', data: maleNorwegianData[5] },
                                { name: '61 to 70 names', data: maleNorwegianData[6] },
                                { name: '71 to 80 names', data: maleNorwegianData[7] },
                                { name: '81 to 90 names', data: maleNorwegianData[8] },
                                { name: '91 to 100 names', data: maleNorwegianData[9] },
                                { name: '101 to 103 names', data: maleNorwegianData[10] },
                                { name: 'quiz' }
                            ]
                        },
                        {
                            name: 'Top 100 surnames',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 surnames', data: norwegianSurnamesData[0] },
                                { name: '11 to 20 surnames', data: norwegianSurnamesData[1] },
                                { name: '21 to 30 surnames', data: norwegianSurnamesData[2] },
                                { name: '31 to 40 surnames', data: norwegianSurnamesData[3] },
                                { name: '41 to 50 surnames', data: norwegianSurnamesData[4] },
                                { name: '51 to 60 surnames', data: norwegianSurnamesData[5] },
                                { name: '61 to 70 surnames', data: norwegianSurnamesData[6] },
                                { name: '71 to 80 surnames', data: norwegianSurnamesData[7] },
                                { name: '81 to 90 surnames', data: norwegianSurnamesData[8] },
                                { name: '91 to 100 surnames', data: norwegianSurnamesData[9] },
                                { name: 'quiz' }
                            ]
                        }
                    ]
                },
                {
                    name: 'Western names',
                    journeys: [
                        {
                            name: 'Top 100 female names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names' },
                                { name: '11 to 20 names' },
                                { name: '21 to 30 names' },
                                { name: '31 to 40 names' },
                                { name: '41 to 50 names' },
                                { name: '51 to 60 names' },
                                { name: '61 to 70 names' },
                                { name: '71 to 80 names' },
                                { name: '81 to 90 names' },
                                { name: '91 to 100 names' },
                                { name: 'quiz' }
                            ]
                        },
                        {
                            name: 'Top 100 male names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names' },
                                { name: '11 to 20 names' },
                                { name: '21 to 30 names' },
                                { name: '31 to 40 names' },
                                { name: '41 to 50 names' },
                                { name: '51 to 60 names' },
                                { name: '61 to 70 names' },
                                { name: '71 to 80 names' },
                                { name: '81 to 90 names' },
                                { name: '91 to 100 names' },
                                { name: 'quiz' }
                            ]
                        },
                        {
                            name: 'Top 100 surnames names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names' },
                                { name: '11 to 20 names' },
                                { name: '21 to 30 names' },
                                { name: '31 to 40 names' },
                                { name: '41 to 50 names' },
                                { name: '51 to 60 names' },
                                { name: '61 to 70 names' },
                                { name: '71 to 80 names' },
                                { name: '81 to 90 names' },
                                { name: '91 to 100 names' },
                                { name: 'quiz' }
                            ]
                        }
                    ]
                },
                {
                    name: 'Asian & Middle-eastern names',
                    journeys: [
                        {
                            name: 'Top 100 female names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names' },
                                { name: '11 to 20 names' },
                                { name: '21 to 30 names' },
                                { name: '31 to 40 names' },
                                { name: '41 to 50 names' },
                                { name: '51 to 60 names' },
                                { name: '61 to 70 names' },
                                { name: '71 to 80 names' },
                                { name: '81 to 90 names' },
                                { name: '91 to 100 names' },
                                { name: 'quiz' }
                            ]
                        },
                        {
                            name: 'Top 100 male names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names' },
                                { name: '11 to 20 names' },
                                { name: '21 to 30 names' },
                                { name: '31 to 40 names' },
                                { name: '41 to 50 names' },
                                { name: '51 to 60 names' },
                                { name: '61 to 70 names' },
                                { name: '71 to 80 names' },
                                { name: '81 to 90 names' },
                                { name: '91 to 100 names' },
                                { name: 'quiz' }
                            ]
                        },
                        {
                            name: 'Top 100 surnames names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names' },
                                { name: '11 to 20 names' },
                                { name: '21 to 30 names' },
                                { name: '31 to 40 names' },
                                { name: '41 to 50 names' },
                                { name: '51 to 60 names' },
                                { name: '61 to 70 names' },
                                { name: '71 to 80 names' },
                                { name: '81 to 90 names' },
                                { name: '91 to 100 names' },
                                { name: 'quiz' }
                            ]
                        }
                    ]
                },
                {
                    name: 'African names',
                    journeys: [
                        {
                            name: 'Top 100 female names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names' },
                                { name: '11 to 20 names' },
                                { name: '21 to 30 names' },
                                { name: '31 to 40 names' },
                                { name: '41 to 50 names' },
                                { name: '51 to 60 names' },
                                { name: '61 to 70 names' },
                                { name: '71 to 80 names' },
                                { name: '81 to 90 names' },
                                { name: '91 to 100 names' },
                                { name: 'quiz' }
                            ]
                        },
                        {
                            name: 'Top 100 male names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names' },
                                { name: '11 to 20 names' },
                                { name: '21 to 30 names' },
                                { name: '31 to 40 names' },
                                { name: '41 to 50 names' },
                                { name: '51 to 60 names' },
                                { name: '61 to 70 names' },
                                { name: '71 to 80 names' },
                                { name: '81 to 90 names' },
                                { name: '91 to 100 names' },
                                { name: 'quiz' }
                            ]
                        },
                        {
                            name: 'Top 100 surnames names',
                            steps: [
                                { name: 'intro' },
                                { name: '1 to 10 names' },
                                { name: '11 to 20 names' },
                                { name: '21 to 30 names' },
                                { name: '31 to 40 names' },
                                { name: '41 to 50 names' },
                                { name: '51 to 60 names' },
                                { name: '61 to 70 names' },
                                { name: '71 to 80 names' },
                                { name: '81 to 90 names' },
                                { name: '91 to 100 names' },
                                { name: 'quiz' }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: 'triplesys',
            name: 'Triple System',
            label: 'XXL',
            journeys: [
                {
                    name: 'Historic events and codes: 000 - 099',
                    steps: [
                        { name: 'intro' },
                        { name: 'Step 1' },
                        { name: 'Step 2' },
                        { name: 'Step 3' },
                        { name: 'quiz' }
                    ]
                },
                {
                    name: 'Historic events and codes: 100 - 199',
                    steps: [
                        { name: 'intro' },
                        { name: 'Step 1' },
                        { name: 'Step 2' },
                        { name: 'Step 3' },
                        { name: 'quiz' }
                    ]
                },
                {
                    name: 'Historic events and codes: 200 - 299',
                    steps: [
                        { name: 'intro' },
                        { name: 'Step 1' },
                        { name: 'Step 2' },
                        { name: 'Step 3' },
                        { name: 'quiz' }
                    ]
                },
                {
                    name: 'Historic events and codes: 300 - 399',
                    steps: [
                        { name: 'intro' },
                        { name: 'Step 1' },
                        { name: 'Step 2' },
                        { name: 'Step 3' },
                        { name: 'quiz' }
                    ]
                },
                {
                    name: 'Historic events and codes: 400 - 499',
                    steps: [
                        { name: 'intro' },
                        { name: 'Step 1' },
                        { name: 'Step 2' },
                        { name: 'Step 3' },
                        { name: 'quiz' }
                    ]
                },
                {
                    name: 'Historic events and codes: 500 - 599',
                    steps: [
                        { name: 'intro' },
                        { name: 'Step 1' },
                        { name: 'Step 2' },
                        { name: 'Step 3' },
                        { name: 'quiz' }
                    ]
                },
                {
                    name: 'Historic events and codes: 600 - 699',
                    steps: [
                        { name: 'intro' },
                        { name: 'Step 1' },
                        { name: 'Step 2' },
                        { name: 'Step 3' },
                        { name: 'quiz' }
                    ]
                },
                {
                    name: 'Historic events and codes: 700 - 799',
                    steps: [
                        { name: 'intro' },
                        { name: 'Step 1' },
                        { name: 'Step 2' },
                        { name: 'Step 3' },
                        { name: 'quiz' }
                    ]
                },
                {
                    name: 'Historic events and codes: 800 - 899',
                    steps: [
                        { name: 'intro' },
                        { name: 'Step 1' },
                        { name: 'Step 2' },
                        { name: 'Step 3' },
                        { name: 'quiz' }
                    ]
                },
                {
                    name: 'Historic events and codes: 900 - 999',
                    steps: [
                        { name: 'intro' },
                        { name: 'Step 1' },
                        { name: 'Step 2' },
                        { name: 'Step 3' },
                        { name: 'quiz' }
                    ]
                }
            ]
        }
    ];

    return systems;
};
